import React from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import ToggleOnOutlinedIcon from "@mui/icons-material/ToggleOnOutlined";
import ToggleOffOutlinedIcon from "@mui/icons-material/ToggleOffOutlined";

/**
 * Compact row actions: View / Edit / Soft-delete / Refresh / PDF / Print / History
 */
const RowActions = ({
  onView,
  onEdit,
  onDelete,
  deleteTitle = "Delete",
  onStatus,
  statusActive,
  onRefresh,
  onPdf,
  onPrint,
  onHistory,
  className = "",
}) => {
  return (
    <div className={`ds-row-actions ${className}`.trim()}>
      {typeof onView === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="View"
          aria-label="View"
          onClick={(e) => {
            e.stopPropagation();
            onView();
          }}
        >
          <VisibilityOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onEdit === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="Edit"
          aria-label="Edit"
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        >
          <EditOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onStatus === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title={statusActive ? "Deactivate" : "Activate"}
          aria-label={statusActive ? "Deactivate" : "Activate"}
          onClick={(e) => {
            e.stopPropagation();
            onStatus();
          }}
        >
          {statusActive ? (
            <ToggleOnOutlinedIcon sx={{ fontSize: 16 }} />
          ) : (
            <ToggleOffOutlinedIcon sx={{ fontSize: 16 }} />
          )}
        </button>
      )}
      {typeof onRefresh === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="Refresh status"
          aria-label="Refresh status"
          onClick={(e) => {
            e.stopPropagation();
            onRefresh();
          }}
        >
          <RefreshOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onPdf === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="Download PDF"
          aria-label="Download PDF"
          onClick={(e) => {
            e.stopPropagation();
            onPdf();
          }}
        >
          <PictureAsPdfOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onPrint === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="Print"
          aria-label="Print"
          onClick={(e) => {
            e.stopPropagation();
            onPrint();
          }}
        >
          <PrintOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onHistory === "function" && (
        <button
          type="button"
          className="ds-row-action"
          title="History"
          aria-label="History"
          onClick={(e) => {
            e.stopPropagation();
            onHistory();
          }}
        >
          <HistoryOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
      {typeof onDelete === "function" && (
        <button
          type="button"
          className="ds-row-action ds-row-action--danger"
          title={deleteTitle}
          aria-label={deleteTitle}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <DeleteOutlineOutlinedIcon sx={{ fontSize: 15 }} />
        </button>
      )}
    </div>
  );
};

export default RowActions;
